export const GOOGLE_LOGO = { uri: '/images/GoogleLogo.png' }
